import { useEffect, useState, useRef } from 'react';
import { getChatHistory } from '../data/dataApi';
import Sidebar from '../views/components/Sidebar';
import Topbar from '../views/components/Topbar';
import { useParams } from 'react-router-dom';
import Message from '../views/components/Message';
import { formatMessages } from '../views/helpers';

const SingleHistory = () => {
    const [messages, setMessages] = useState([]);

    const { sessionId } = useParams();

    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current) return; // Dev mode fix

        (async () => {
            const response = await getChatHistory(sessionId);

            if (response.success) {
                const { data } = response;

                const reverseMessages = (messages) => {
                    const chunks = [];
                    for (let i = 0; i < messages.length; i += 2) {
                        chunks.push(messages.slice(i, i + 2));
                    }

                    const orderedChunks = chunks.map(chunk => {
                        if (chunk.length === 2 && chunk[0].type === 'apiMessage' && chunk[1].type === 'userMessage') {
                            return [chunk[1], chunk[0]];
                        }
                        return chunk;
                    });

                    const reversedChunks = orderedChunks.reverse();

                    const reversedArray = reversedChunks.flat();

                    return reversedArray;
                };

                setMessages(reverseMessages(formatMessages(data[sessionId])));
            }
        })();

        effectRan.current = true;
    }, []);

    return (
        <>
            <div id="history" className="d-flex">
                <Sidebar />
                <div className="flex-grow-1">
                    <Topbar title="Chat History" backButton />
                    <div className="content-wrapper">
                        <div className="messages-wrapper">
                            {
                                messages.map((message, index) => (
                                    <Message
                                        messages={messages}
                                        message={message}
                                        key={index}
                                    />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SingleHistory;
